jQuery(document).ready(function() {
    jQuery("#show_hide_password a").on('click', function(event) {
        event.preventDefault();
        if(jQuery('#show_hide_password input').attr("type") == "text"){
            jQuery('#show_hide_password input').attr('type', 'password');

        }else if(jQuery('#show_hide_password input').attr("type") == "password"){
            jQuery('#show_hide_password input').attr('type', 'text');
        }
    });
});